<template>
    <div style="font-size:14px;">

        <v-layout>
            <v-container style="text-align:left;padding:40px;" class="">
                <v-row>
                   <v-col cols="12" md="12" lg="2" xl="2" style="background-color:#fafbff;">
                        <nav class="" style="background-color:#fafbff;font-weight:600;">

                            <v-list nav v-model:opened="open">
                            <v-list-group value="oweb" >
                                    <template v-slot:activator="{ props }">
                                      <v-list-item
                                        v-bind="props"
                                        title="Onkopus Web"
                                      ></v-list-item>
                                    </template>

                                    <v-list>
                                            <v-list-item value="start">
                                                <v-list-item-content>
                                                    <router-link to="/docs/"  style="text-decoration:None;">
                                                        Getting started
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="search">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#upload-data"  style="text-decoration:None;">
                                                        Upload data
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#docs-variant-analysis"  style="text-decoration:None;">
                                                        Variant analysis
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#docs-variant-detail"  style="text-decoration:None;">
                                                        Detailed variant view
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <!--<v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#docs-variant-treatments"  style="text-decoration:None;">
                                                        Treatments
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#docs-variant-protein"  style="text-decoration:None;">
                                                        Protein analysis
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>-->
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/#docs-variant-save"  style="text-decoration:None;">
                                                        Saving your results
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                    </v-list>
                                </v-list-group>
                            </v-list>

                            <v-list nav v-model:opened="open">
                            <v-list-group value="oweb" >
                                    <template v-slot:activator="{ props }">
                                      <v-list-item
                                        v-bind="props"
                                        title="Python package"
                                      ></v-list-item>
                                    </template>

                                    <v-list>
                                            <v-list-item value="start">
                                                <v-list-item-content>
                                                    <router-link to="/docs/python"  style="text-decoration:None;">
                                                        Installation
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="search">
                                                <v-list-item-content>
                                                    <router-link to="/docs/python#python-liftover"  style="text-decoration:None;">
                                                        Liftover
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/python#python-annotation"  style="text-decoration:None;">
                                                        Variant annotation
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/python#python-proteintogenomic"  style="text-decoration:None;">
                                                        Protein to genomic conversion
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="detailview">
                                                <v-list-item-content>
                                                    <router-link to="/docs/python#python-save"  style="text-decoration:None;">
                                                        Saving data
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                    </v-list>
                                </v-list-group>
                            </v-list>

                            <v-list nav v-model:opened="open">
                            <v-list-group value="oweb" >
                                    <template v-slot:activator="{ props }">
                                      <v-list-item
                                        v-bind="props"
                                        title="KNIME workflows"
                                      ></v-list-item>
                                    </template>

                                    <v-list>
                                            <v-list-item value="start">
                                                <v-list-item-content>
                                                    <router-link to="/docs/knime"  style="text-decoration:None;">
                                                        Installation
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item value="search">
                                                <v-list-item-content>
                                                    <router-link to="/docs/knime#simple-workflow"  style="text-decoration:None;">
                                                        Creating a simple workflow
                                                    </router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                    </v-list>
                                </v-list-group>
                            </v-list>



                        </nav>
                   </v-col>

                   <v-col cols="12" md="12" lg="10" xl="10">
                          <main style="flex: 1; padding: 2rem;">
                            <router-view></router-view>
                          </main>
                   </v-col>

                   <v-col cols="0" md="0" lg="2" xl="2" justify="left" align="left">
                   </v-col>
        </v-row>
        </v-container>
                </v-layout>
    </div>
</template>
<script>
import {ref} from "vue"

export default {
    methods: {
        scrollMeTo(refName) {
            const el = this.$refs[refName]
            el.scrollIntoView({ behavior: 'smooth'})
        },
        scrollToSection(id) {
            this.$nextTick(() => {
              this.$router.onReady(() => {
                this.$nextTick(() => {
                  const element = document.getElementById(id);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                });
              });
            });
          },
    },
    data: () => ({
        open: ['oweb'],
    }),
}
</script>
<style>
        pre {
            background-color: #f4f4f4;
            padding: 10px;
            border: 1px solid #ddd;
            border-radius: 5px;
            overflow-x: auto;
        }

        code {
            color: #333;
            font-family: Consolas, Monaco, "Courier New", monospace;
            font-size: 1em;
        }

        /* Syntax highlighting */
        .keyword { color: #d73a49; font-weight: bold; }
        .string { color: #032f62; }
        .comment { color: #6a737d; font-style: italic; }
        .function { color: #005cc5; }
        .number { color: #005cc5; }
</style>
